import { FaceManOutlineIcon } from './FaceManOutlineIcon';

/**
 * author: Google
 * id CFDA13BC-C61A-4FE0-8094-7B51E8EB3F82
 * name face-man-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-man-outline.svg
 * tags
 * - People / Family 
 */
export const FaceMaleOutlineIcon = FaceManOutlineIcon;
export default FaceMaleOutlineIcon